import React, { useEffect, useRef, useState,useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAcsCode } from "./redux/CodeBookSlicer";
import { useLocation } from "react-router-dom";
import closeIcon from "../../common/assets/images/close-icon.png";
import { Table } from "react-bootstrap";
import { useDocSearch } from "./documentSearch/useDocSearch";
import SearchNavBar from "./documentSearch/SearchNavBar";
import { DomSearchEngine } from "./documentSearch/searchEngines";
import { IframeSearchEngine } from "./documentSearch/searchEngines";

const ACSCodeBook13th = ({query = ""}) => {
  const [iframeSrc, setIframeSrc] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [codeList, setCodeList] = useState([]);
  const [activeNames, setActiveNames] = useState([]);
  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const scrollRef = useRef(null);

  const { acsCode } = useSelector((state) => state.codeBook);
  console.log("acsCode:", acsCode);
const engine = useMemo(() => new IframeSearchEngine(), []);
engine.setRef(iframeRef); // ← add this
const search = useDocSearch(engine, scrollRef);
     // Pass search to iframe engine when query changes
      // Fire search into the iframe when query changes
  // useEffect(() => {
  //   if (query?.length >= 2) {
  //     const timer = setTimeout(() => engine.search(query), 250);
  //     return () => clearTimeout(timer);
  //   } else {
  //     engine.clear();
  //   }
  // }, [query, engine]);
    useEffect(() => {
    console.log("query useEffect fired, query:", query, "length:", query?.length); // ← check 2: is effect firing?
    if (query?.length >= 2) {
      const timer = setTimeout(() => {
        console.log("calling engine.search with:", query); // ← check 3: is search being called?
        engine.search(query);
      }, 250);
      return () => clearTimeout(timer);
    } else {
      engine.clear();
    }
  }, [query, engine]);
  
  console.log("ACSCodeBook13th query prop:", query);

  // const [iframeReady, setIframeReady] = useState(false);

  // Scroll helper
  // const scrollToAcsCode = () => {
  //   if (!acsCode || acsCode.includes(",")) return;
  //   if (!iframeRef.current) return;

  //   const iframeDoc =
  //     iframeRef.current.contentDocument ||
  //     iframeRef.current.contentWindow?.document;
  //   if (!iframeDoc) return;

  //   const padded = acsCode.toString().padStart(4, "0");
  //   const targetId = `acs-${padded}`;
  //   const target = iframeDoc.getElementById(targetId);

  //   if (target) {
  //     const scrollContainer = iframeDoc.scrollingElement || iframeDoc.body;

  //     // Delay ensures layout is painted
  //     setTimeout(() => {
  //       scrollContainer.scrollTo({
  //         top: target.offsetTop - 20,
  //         behavior: "smooth",
  //       });
  //     }, 100);

  //     const matched = chapterNamesToMapInTable.find((c) => c.path === padded);
  //     const name = matched ? matched.name : `Code ${padded}`;
  //     setActiveNames([{ code: padded, name }]);
  //   }
  // };

  // 🔹 Watch for acsCode + iframeReady together
  // useEffect(() => {
  //   if (iframeReady && acsCode && !acsCode.includes(",")) {
  //     scrollToAcsCode();
  //   }
  // }, [iframeReady, acsCode]);

  const chapterNamesToMapInTable = [
    { name: "Principal diagnosis", path: "0001" },
    { name: "Additional diagnoses", path: "0002" },
    { name: "Supplementary codes for chronic conditions", path: "0003" },
    { name: "Syndromes", path: "0005" },
    { name: "Sequelae", path: "0008" },
    {
      name: "Clinical documentation and general abstraction guidelines",
      path: "0010",
    },
    { name: "Intervention cancelled or not performed", path: "0011" },
    { name: "Suspected conditions", path: "0012" },
    { name: "Combination codes", path: "0015" },
    { name: "Double coding", path: "0025" },
    {
      name: "Admission for clinical trial or therapeutic drug monitoring",
      path: "0026",
    },
    { name: "Condition onset flag", path: "0048" },
    { name: "Disease codes that must never be assigned", path: "0049" },
    { name: "Unacceptable principal diagnosis codes", path: "0050" },
    { name: "Same-day endoscopy – diagnostic", path: "0051" },
    { name: "Same-day endoscopy – surveillance", path: "0052" },
    { name: "General procedure guidelines", path: "0016" },
    {
      name: "Intervention abandoned, interrupted or not completed",
      path: "0019",
    },
    { name: "Bilateral/multiple procedures", path: "0020" },
    { name: "Examination under anaesthesia", path: "0022" },
    { name: "Minimally invasive interventions", path: "0023" },
    { name: "Panendoscopy", path: "0024" },
    { name: "Coding of contracted procedures", path: "0029" },
    {
      name: "Organ, tissue and cell procurement and transplantation",
      path: "0030",
    },
    { name: "Anaesthesia", path: "0031" },
    { name: "Allied health interventions", path: "0032" },
    { name: "Paediatric procedures", path: "0037" },
    {
      name: "Procedures distinguished on the basis of size, time, number of lesions or sites",
      path: "0038",
    },
    { name: "Reopening of operative site", path: "0039" },
    { name: "Procedures normally not coded", path: "0042" },
    { name: "Pharmacotherapy", path: "0044" },
    { name: "Adhesions", path: "0047" },
    {
      name: "HIV/AIDS (human immunodeficiency virus/acquired immune deficiency syndrome)",
      path: "0102",
    },
    { name: "Viral hepatitis", path: "0104" },
    { name: "Sepsis and septic shock", path: "0110" },
    {
      name: "Healthcare associated Staphylococcus aureus bloodstream infection",
      path: "0111",
    },
    { name: "Infection with drug resistant microorganisms", path: "0112" },
    { name: "Coronavirus disease 2019 (COVID-19)", path: "0113" },
    { name: "Pharmacotherapy for neoplasms", path: "0206" },
    { name: "Lymphoma", path: "0222" },
    { name: "Radiotherapy", path: "0229" },
    { name: "Morphology", path: "0233" },
    {
      name: "Neoplasms of contiguous or overlapping sites, or with localised spread",
      path: "0234",
    },
    { name: "Neoplasm coding and sequencing", path: "0236" },
    { name: "Recurrence of malignancy", path: "0237" },
    { name: "Metastases", path: "0239" },
    {
      name: "Remission in malignant immunoproliferative diseases and leukaemia",
      path: "0245",
    },
    { name: "Blood transfusions", path: "0302" },
    {
      name: "Anticoagulant use and abnormal coagulation profile",
      path: "0303",
    },
    { name: "Pancytopenia", path: "0304" },
    { name: "Diabetes mellitus and intermediate hyperglycaemia", path: "0401" },
    { name: "Cystic fibrosis", path: "0402" },
    { name: "Drug, alcohol and tobacco use disorders", path: "0503" },
    {
      name: "Mental illness in pregnancy, childbirth and the puerperium",
      path: "0505",
    },
    { name: "Adjustment/depressive reaction", path: "0506" },
    { name: "Personality trait/disorder", path: "0512" },
    { name: "Drug overdose", path: "0530" },
    {
      name: "Specific interventions related to mental health care services",
      path: "0534",
    },
    { name: "Cerebrovascular accident (CVA)", path: "0604" },
    { name: "Quadriplegia and paraplegia, nontraumatic", path: "0625" },
    {
      name: "Stereotactic radiosurgery, radiotherapy and localisation",
      path: "0629",
    },
    { name: "Stereotactic neurosurgery", path: "0633" },
    {
      name: "Cerebrospinal fluid drain, shunt and ventriculostomy",
      path: "0634",
    },

    { name: "Cataract", path: "0701" },
    { name: "Coronary artery bypass grafts", path: "0909" },
    { name: "Hypertension and related conditions", path: "0925" },
    { name: "Cardiac catheterisation and coronary angiography", path: "0933" },
    {
      name: "Cardiac and vascular revision/reoperation procedures",
      path: "0934",
    },
    { name: "Cardiac pacemakers and implanted defibrillators", path: "0936" },
    { name: "Ischaemic heart disease", path: "0940" },
    { name: "Arterial disease", path: "0941" },
    { name: "Ventilatory support", path: "1006" },
    { name: "Chronic obstructive pulmonary disease (COPD)", path: "1008" },
    { name: "Influenza due to identified influenza virus", path: "1012" },
    { name: "Gastrointestinal (GI) haemorrhage", path: "1103" },

    { name: "Plastic surgery", path: "1204" },
    { name: "Pressure injury", path: "1221" },

    { name: "Dislocation or complication of joint prosthesis", path: "1309" },
    { name: "Bankart lesion", path: "1353" },
    { name: "SLAP lesion", path: "1354" },

    { name: "Admission for kidney dialysis", path: "1404" },
    { name: "Diethylstilboestrol (DES) syndrome", path: "1428" },
    { name: "Chronic kidney disease", path: "1438" },
    {
      name: "Diagnosis sequencing in obstetric episodes of care",
      path: "1500",
    },
    { name: "Delivery and assisted delivery codes", path: "1505" },
    {
      name: "Fetal presentation, disproportion and abnormality of maternal pelvic organs",
      path: "1506",
    },
    { name: "Termination of pregnancy (abortion)", path: "1511" },
    { name: "Conditions and injuries in pregnancy", path: "1521" },
    {
      name: "Complications following pregnancy with abortive outcome",
      path: "1544",
    },
    { name: "Puerperal/postpartum condition or complication", path: "1548" },
    {
      name: "Streptococcal group B infection/carrier in pregnancy",
      path: "1549",
    },
    { name: "Discharge/transfer in labour", path: "1550" },
    { name: "Obstetric perineal lacerations/grazes", path: "1551" },
    {
      name: "Premature rupture of membranes, labour delayed by therapy",
      path: "1552",
    },
    { name: "Neonatal complications of maternal diabetes", path: "1602" },
    { name: "Conditions originating in the perinatal period", path: "1605" },
    { name: "Newborn/neonate", path: "1607" },
    {
      name: "Sudden infant death syndrome/apparent life threatening event",
      path: "1610",
    },
    {
      name: "Observation and evaluation of newborn and infants for suspected condition not found",
      path: "1611",
    },
    { name: "Massive aspiration syndrome", path: "1613" },
    {
      name: "Specific diseases and interventions related to the sick neonate",
      path: "1615",
    },
    { name: "Neonatal sepsis/risk of sepsis", path: "1617" },
    { name: "Acopia", path: "1805" },
    { name: "Poisoning", path: "1901" },
    { name: "Adverse effects", path: "1902" },
    { name: "Two or more drugs taken in combination", path: "1903" },
    { name: "Procedural complications", path: "1904" },
    {
      name: "Closed head injury/loss of consciousness/concussion",
      path: "1905",
    },
    { name: "Current and old injuries", path: "1906" },
    { name: "Multiple injuries", path: "1907" },
    {
      name: "Open wound with artery, nerve and/or tendon damage",
      path: "1908",
    },
    { name: "Adult and child abuse", path: "1909" },
    { name: "Skin loss", path: "1910" },
    { name: "Burns", path: "1911" },
    {
      name: "Sequelae of injuries, poisoning, toxic effects and other external causes",
      path: "1912",
    },
    { name: "Degloving injury", path: "1914" },
    { name: "Spinal (cord) injury", path: "1915" },
    { name: "Superficial and soft tissue injuries", path: "1916" },
    { name: "Open wounds", path: "1917" },
    { name: "Fracture and dislocation", path: "1918" },
    { name: "Open intracranial injury", path: "1919" },
    { name: "Open intrathoracic/intra-abdominal injury", path: "1920" },
    { name: "Crushing injury", path: "1922" },
    { name: "Contact with venomous/nonvenomous creatures", path: "1923" },
    { name: "Difficult intubation", path: "1924" },
    { name: "External cause code use and sequencing", path: "2001" },
    { name: "Poisonings and injuries – indication of intent", path: "2005" },
    { name: "Perpetrator of assault, abuse and neglect", path: "2008" },
    { name: "Mode of pedestrian conveyance", path: "2009" },
    { name: "Admission for post acute care", path: "2103" },
    { name: "Rehabilitation", path: "2104" },
    { name: "Long term/nursing home type inpatients", path: "2105" },
    { name: "Assessment", path: "2108" },
    { name: "Prophylactic surgery", path: "2114" },
    { name: "Admission for allergen challenge", path: "2115" },
    { name: "Palliative care", path: "2116" },
    { name: "Non-acute care", path: "2117" },
    { name: "Exposure to tobacco smoke", path: "2118" },
    { name: "Socioeconomic and psychosocial circumstances", path: "2119" },
  ];

  // useEffect(() => {
  //   dispatch(clearAcsCode());
  // }, [location.pathname, dispatch]);
  useEffect(() => {
    if (acsCode) {
      engine.clear();
    }
  }, [acsCode]);
  useEffect(() => {
    if (!acsCode) return;

    if (acsCode.includes(",")) {
      const codes = acsCode.split(",").map((c) => c.trim().padStart(4, "0"));
      setCodeList(codes);
      setOpenModal(true);
      setIframeSrc("/ACS_TOC_bookmarked 2.htm");
    } else {
      const padded = acsCode.toString().padStart(4, "0");
      setIframeSrc("/ACS_TOC_bookmarked 2.htm");
      setOpenModal(false);
      setCodeList([]);
    }
  }, [acsCode]);
useEffect(() => {
  setIframeSrc("/ACS_TOC_bookmarked 2.htm");
}, []);

// Scroll function
const scrollToACSCode = (code) => {
  if (!iframeRef.current) return;

  const iframeDoc =
    iframeRef.current.contentDocument ||
    iframeRef.current.contentWindow?.document;
  if (!iframeDoc) return;

  const padded = code?.padStart(4, "0");
  const target = iframeDoc.getElementById(`acs-${padded}`);
  if (target) {
    const scrollContainer = iframeDoc.scrollingElement || iframeDoc.body;
    scrollContainer.scrollTo({
      top: target.offsetTop - 20,
      behavior: "smooth",
    });

    const nameText = target.textContent?.trim() || `Code ${padded}`;
    setActiveNames([{ code: padded, name: nameText }]);
  }
};

// When acsCode changes
useEffect(() => {
  if (!acsCode) return;

  if (acsCode.includes(",")) {
    const codes = acsCode.split(",").map((c) => c.trim().padStart(4, "0"));
    const enriched = codes.map((code) => {
      const matched = chapterNamesToMapInTable.find((c) => c.path === code);
      const name = matched ? matched.name : `Code ${code}`;
      return { code, name };
    });
    setCodeList(enriched);
    setOpenModal(true);
  } else {
    setCodeList([]);
    setOpenModal(false);
    setTimeout(() => scrollToACSCode(acsCode), 300);
  }
}, [acsCode]);

const handleModalClick = (code) => {
  setOpenModal(false);
  setTimeout(() => scrollToACSCode(code), 100);
};



  // const handleModalClick = (code) => {
  //   const padded = code.padStart(4, "0");
  //   const targetId = `acs-${padded}`;

  //   setOpenModal(false);
  //    setIframeSrc(`/ACS_TOC_bookmarked 2.htm#${targetId}`);
  //   setTimeout(() => {
  //     const iframeDoc =
  //       iframeRef.current?.contentDocument ||
  //       iframeRef.current?.contentWindow?.document;
  //     if (!iframeDoc) return;

  //     const target = iframeDoc.getElementById(targetId);
  //     if (target) {
  //       const scrollContainer = iframeDoc.scrollingElement || iframeDoc.body;

  //       scrollContainer.scrollTo({
  //         top: target.offsetTop - 20,
  //         behavior: "smooth",
  //       });

  //       const nameText = target.textContent?.trim() || `Code ${code}`;
  //       setActiveNames([{ code, name: nameText }]);
  //     }
  //   }, 200);
  // };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleLinkClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;

      e.preventDefault();
    };

    container.addEventListener("click", handleLinkClick);
    return () => container.removeEventListener("click", handleLinkClick);
  }, []);

  console.log(activeNames, "activeNames");
  return (
    <div
      ref={scrollRef}
      style={{
        height: "57vh",
        width: "100%",
        position: "relative",
        // overflowY: "auto",
      }}
    >
      <SearchNavBar {...search} />
      {openModal && (
        <div className="acs-links-modal-overlay-fade">
          <div className="acs-links-modal-container">
            <div className="acs-links-modal-header">
              <p className="acs-links-modal-header-text">ACS Links</p>
              <p
                className="acs-links-modal-header-img"
                onClick={() => setOpenModal(false)}
              >
                <img src={closeIcon} alt="x" />
              </p>
            </div>
            <div className="acs-links-modal-body">
              <Table style={{ width: "100%" }}>
                <thead>
                  <tr className="workflow-him-table-tr">
                    <th>Name</th>
                    <th>Code</th>
                  </tr>
                </thead>
                <tbody>
                  {codeList.map((item, index) => (
                    <tr
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleModalClick(item.code)}
                    >
                      <td className="acs-link-td-text">{item.name}</td>
                      <td className="acs-link-td-text">{item.code}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}
      
        <iframe
          ref={iframeRef}
          src={iframeSrc}
          title="CODE Book 13th Edition"
          style={{ width: "100%", height: "100%", border: "none" }}
          scrolling="yes"
          onLoad={() => {
            // setIframeReady(true);
             engine.onLoad();   // ← Very Important
            if (acsCode && !acsCode.includes(",")) {
              setTimeout(scrollToACSCode(acsCode), 50); // scroll right after load
            }

            // intercept anchors inside iframe
            const iframeDoc =
              iframeRef.current?.contentDocument ||
              iframeRef.current?.contentWindow?.document;
            if (iframeDoc) {
              iframeDoc.querySelectorAll('a[href^="#"]').forEach((a) => {
                a.addEventListener("click", (e) => e.preventDefault());
              });
            }
          }}
        />
      
    </div>
  );
};

export default ACSCodeBook13th;
